import * as React from 'react';
import { Slot as SlotProps } from './model';
import Slide from '../Slide';
import { SlotStyle, SlotButton, SkyscraperLabel, CarouselSlot, CarouselSlotLabel, SlotLabel, SlotDisclaimer, CarouselSlotDisclaimer, SlotHoverContainer, LobbyLabel } from './styles';

const onClick = ({ openModal, type, media, url, content, target }) => {
  if (type === 'article') {
    return openModal({type, media, url});
  }
  console.log('url:', url, 'target:', target);
  window.open(url, target);
}

const Slot = ({
  id,
  // type,
  region = 'NA',
  language = 'en',
  label: labelPack,
  disclaimer: disclaimerPack,
  slotItemList,
  hoverMedia,
  width,
  height,
  openModal,
  textAlign,
  // content,
  // media,
  type: slotType,
  ctaUrl = ''
}: SlotProps) => {
  console.log('slotType', slotType);
  const { content, type, media, ctaUrl : urlPack } = slotItemList[0];
  const label = labelPack[`${language}-${region}`];
  const disclaimer = disclaimerPack ? disclaimerPack[`${language}-${region}`] : '';
  const url = urlPack ? urlPack[`${language}-${region}`] : '';
  const target = url.indexOf('http') === -1 ? '_self' : '_blank';
  // console.log('hoverMedia', hoverMedia);
  if (hoverMedia) {
    console.log('hoverMedia', hoverMedia.url);
  }
  if (slotType === 'carousel') return <CarouselSlot
    href={url}
    target={target}
  >
    <img src={media.url} />
    <CarouselSlotLabel>{label}</CarouselSlotLabel>
    <CarouselSlotDisclaimer>{disclaimer}</CarouselSlotDisclaimer>
  </CarouselSlot>;
  return <SlotButton className={`lang-${language}`} onClick={() => onClick({ openModal, type, content, media, url, target })}>
      <SlotStyle>
      {slotItemList.map((slotItem, index) => {
        // TODO: Make dynamic based on slot type
        return <Slide key={slotItem.id} {...slotItem} height={height} width={width} />;
      })}
      {hoverMedia && <SlotHoverContainer><img src={hoverMedia.url} height={height}/></SlotHoverContainer>}
      {(slotType === 'skyscraper' || slotType === 'compact') && <SkyscraperLabel language={language} textAlign={textAlign}>{label}</SkyscraperLabel>}
      {(slotType === 'lobby') && <LobbyLabel textAlign={textAlign}>{label}<SlotDisclaimer>{disclaimer}</SlotDisclaimer></LobbyLabel>}
    </SlotStyle>
    {((slotType != 'skyscraper' && slotType != 'lobby' && slotType != 'compact') && slotType != 'compact') && <SlotLabel>{label}<SlotDisclaimer>{disclaimer}</SlotDisclaimer></SlotLabel>}
  </SlotButton>
};

export default Slot;
